export const splitGrapheme = (str: string) => {
  try {
    const segmenter = new Intl.Segmenter("ja", { granularity: "grapheme" });
    return [...segmenter.segment(str)].map((seg) => seg.segment);
  } catch (e) {
    return Array.from(str);
  }
};
